import React from 'react';
import { useNavigate } from 'react-router-dom';
import CoverPlate from './CoverPlate';
import { fmtDuration } from '../../utils/format';

export default function HorizontalCard({ video, progress, width = 200, onClick }) {
    const navigate = useNavigate();

    return (
        <a
            href={`/watch/${video.id}`}
            onClick={(e) => { e.preventDefault(); onClick ? onClick() : navigate(`/watch/${video.id}`); }}
            style={{
                flexShrink: 0, width,
                display: 'flex', flexDirection: 'column', gap: 8,
                textDecoration: 'none', padding: 0,
                cursor: 'pointer', color: 'inherit',
            }}
        >
            <div style={{ position: 'relative' }}>
                <CoverPlate video={video} ratio="16/10" size="sm" radius={10} />
                {progress != null && (
                    <div style={{
                        position: 'absolute', left: 8, right: 8, bottom: 8,
                        height: 3, borderRadius: 3,
                        background: 'rgba(255,255,255,0.22)', overflow: 'hidden',
                    }}>
                        <div style={{
                            height: '100%', width: `${Math.min(1, progress) * 100}%`,
                            background: '#e60073', borderRadius: 3,
                        }} />
                    </div>
                )}
            </div>
            <div>
                <div style={{
                    fontSize: 12.5, fontWeight: 600, lineHeight: 1.3, color: '#fff',
                    display: '-webkit-box', WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical', overflow: 'hidden',
                }}>
                    {video.title}
                </div>
                <div style={{
                    marginTop: 2,
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: 10, color: '#71717A',
                }}>
                    {fmtDuration(video.duration)}
                </div>
            </div>
        </a>
    );
}
